var _defs, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFrenoEmergencia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#GradientFill_3-4);\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: url(#GradientFill_3-2);\n      }\n\n      .cls-3 {\n        fill: url(#GradientFill_3-3);\n      }\n\n      .cls-4 {\n        fill: url(#GradientFill_3);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_3",
    "data-name": "GradientFill 3",
    x1: 25,
    y1: 50,
    x2: 25,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aa780c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#d1b24a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e5d06a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_3-2",
    "data-name": "GradientFill 3",
    x1: 25,
    y1: 50.01,
    x2: 25,
    y2: 0.01,
    xlinkHref: "#GradientFill_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_3-3",
    "data-name": "GradientFill 3",
    x1: 25,
    y1: 50.01,
    x2: 25,
    y2: 0.01,
    xlinkHref: "#GradientFill_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_3-4",
    "data-name": "GradientFill 3",
    x1: 25.01,
    y1: 50.01,
    x2: 25.01,
    y2: 0.01,
    xlinkHref: "#GradientFill_3"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M25,3.06C12.9,3.06,3.06,12.9,3.06,25s9.84,21.94,21.94,21.94,21.94-9.84,21.94-21.94S37.1,3.06,25,3.06M25,50C11.22,50,0,38.78,0,25S11.22,0,25,0s25,11.21,25,25-11.22,25-25,25"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M25.03,41.93c-.37,0-.73-.06-1.07-.19-8.65-2.99-12.87-7.98-12.87-15.27v-10.82c0-1.71,1.39-3.09,3.09-3.09,2.5,0,6.05-1.57,8.63-3.82,1.28-1.09,3.11-1.09,4.37-.01,2.63,2.3,6.1,3.83,8.64,3.83,1.7,0,3.09,1.39,3.09,3.09v10.82c0,7.27-4.21,12.28-12.88,15.3-.33.11-.67.17-1.01.17ZM25,11.01c-.06,0-.12.02-.17.06-3.18,2.78-7.36,4.58-10.65,4.58v10.82c0,5.88,3.44,9.81,10.82,12.36,7.39-2.55,10.83-6.49,10.83-12.36v-10.82c-3.29,0-7.48-1.8-10.66-4.59-.04-.04-.1-.05-.15-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M25,26.47c-.85,0-1.55-.69-1.55-1.55v-6.18c0-.85.69-1.55,1.55-1.55s1.55.69,1.55,1.55v6.18c0,.85-.69,1.55-1.55,1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.01,32.65c-.85,0-1.55-.69-1.55-1.55s.68-1.55,1.54-1.55h.02c.85,0,1.55.69,1.55,1.55s-.69,1.55-1.55,1.55Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFrenoEmergencia);
export default __webpack_public_path__ + "static/media/Icon_FrenoEmergencia.c6ed57693ba9b58b5616cdb009a407b6.svg";
export { ForwardRef as ReactComponent };